<template>
  <div class="about-page">
    <!-- Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="#home">
          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="50" class="me-3">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('/')">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('about')">About</a>
            </li>
            <li class="nav-item d-none">
              <a class="nav-link" href="#how-it-works">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#benefits">Benefits</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Health Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#enrollment">Enrollment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#facilities">Health Facilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faqs">FAQs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>

            <li class="nav-item dropdown ms-3">
              <button class="btn btn-primary dropdown-toggle" type="button"
                      id="loginDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bx bx-user me-2"></i>Login
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                <li>
                  <a class="dropdown-item" @click="goToMemberLogin">
                    <i class="bx bx-user-circle me-2"></i>Member Portal
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" @click="goToStaffLogin">
                    <i class="bx bx-briefcase me-2"></i>Staff Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Page Header / Hero -->
    <section class="page-header">
      <div class="header-overlay"></div>
      <div class="header-pattern"></div>
      <div class="container">
        <div class="row align-items-center min-vh-50 py-5">
          <div class="col-lg-8 text-white">
            <nav aria-label="breadcrumb" class="mb-4">
              <ol class="breadcrumb breadcrumb-light">
                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">About Us</li>
              </ol>
            </nav>
            <h1 class="display-3 fw-bold mb-4 animate-on-scroll text-white">About Us</h1>
            <p class="lead mb-0 animate-on-scroll">
              Learn about PONA HEALTH-X, our community-based health insurance program,
              our leadership, and our commitment to providing universal healthcare for all.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Quick Navigation Tabs -->
    <section class="quick-nav py-4 bg-white shadow-sm sticky-top" style="top: 70px; z-index: 999;">
      <div class="container">
        <div class="nav-scroll-container">
          <ul class="nav nav-pills nav-quick justify-content-center flex-nowrap">
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'organization' }"
                 @click="scrollToSection('organization')">
                <i class="bx bx-buildings me-2 text-white"></i> <span class="text-white">Organization</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'pona' }"
                 @click="scrollToSection('pona')">
                <i class="bx bx-shield-check me-2"></i>About PONA HEALTH-X
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'vision' }"
                 @click="scrollToSection('vision')">
                <i class="bx bx-target-lock me-2"></i>Vision & Mission
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'leadership' }"
                 @click="scrollToSection('leadership')">
                <i class="bx bx-user-voice me-2"></i>Leadership
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'structure' }"
                 @click="scrollToSection('structure')">
                <i class="bx bx-sitemap me-2"></i>Structure
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'history' }"
                 @click="scrollToSection('history')">
                <i class="bx bx-history me-2"></i>History
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection === 'partners' }"
                 @click="scrollToSection('partners')">
                <i class="bx bx-globe me-2"></i>Partners
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Organization Section -->
    <section id="organization" class="py-5">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-5 mb-lg-0 animate-on-scroll">
            <div class="image-showcase">
              <img src="https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=600"
                   alt="PONA HEALTH-X Organization"
                   class="img-fluid rounded-4 main-image">
              <div class="image-badge">
                <i class="bx bx-buildings"></i>
                <span>Est. 2018</span>
              </div>
              <div class="floating-card">
                <div class="floating-stat">
                  <span class="stat-value">7+</span>
                  <span class="stat-text">Years of Service</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-buildings"></i></span>
              <span class="label-text">About the Organization</span>
            </div>
            <h2 class="display-5 fw-bold mb-4">
              PONA HEALTH-X
              <span class="text-gradient">Insurance</span>
            </h2>
            <p class="lead text-muted mb-4">
              PONA HEALTH-X is responsible for the overall health insurance policy, strategy development,
              and stewardship of community-based health insurance systems.
            </p>
            <p class="mb-4">
              Established in 2018, PONA HEALTH-X has been at the forefront of improving the health
              status of communities through policy formulation, resource mobilization, regulatory
              functions, and coordination of health services delivery across the nation.
            </p>

            <div class="key-facts">
              <div class="row g-3">
                <div class="col-6">
                  <div class="fact-card">
                    <div class="fact-icon bg-primary-soft">
                      <i class="bx bx-buildings text-primary"></i>
                    </div>
                    <div class="fact-content">
                      <h4 class="fact-number">311+</h4>
                      <p class="fact-label">Hospitals</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="fact-card">
                    <div class="fact-icon bg-success-soft">
                      <i class="bx bx-plus-medical text-success"></i>
                    </div>
                    <div class="fact-content">
                      <h4 class="fact-number">3,500+</h4>
                      <p class="fact-label">Health Centers</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="fact-card">
                    <div class="fact-icon bg-info-soft">
                      <i class="bx bx-clinic text-info"></i>
                    </div>
                    <div class="fact-content">
                      <h4 class="fact-number">16,000+</h4>
                      <p class="fact-label">Health Posts</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="fact-card">
                    <div class="fact-icon bg-warning-soft">
                      <i class="bx bx-user-plus text-warning"></i>
                    </div>
                    <div class="fact-content">
                      <h4 class="fact-number">42,000+</h4>
                      <p class="fact-label">Health Workers</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Organization Responsibilities -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-list-check"></i></span>
            <span class="label-text">Core Functions</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Our Responsibilities</h2>
          <p class="lead text-muted">Key areas of focus and mandate of PONA HEALTH-X</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 col-md-6 animate-on-scroll" v-for="(resp, index) in responsibilities" :key="index">
            <div class="responsibility-card h-100">
              <div class="resp-icon" :class="resp.colorClass">
                <i :class="resp.icon"></i>
              </div>
              <h5 class="fw-bold mb-3">{{ resp.title }}</h5>
              <p class="text-muted mb-0">{{ resp.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About PONA HEALTH-X Section -->
    <section id="pona" class="py-5">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 order-lg-2 mb-5 mb-lg-0 animate-on-scroll">
            <div class="image-showcase reverse">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600"
                   alt="Healthcare Coverage"
                   class="img-fluid rounded-4 main-image">
              <div class="image-badge right">
                <i class="bx bx-shield-check"></i>
                <span>Since 2018</span>
              </div>
              <div class="floating-card right">
                <div class="floating-stat">
                  <span class="stat-value">15M+</span>
                  <span class="stat-text">Members Enrolled</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 order-lg-1 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-shield-check"></i></span>
              <span class="label-text">Health Insurance</span>
            </div>
            <h2 class="display-5 fw-bold mb-4">
              Community-Based
              <span class="text-gradient">Health Insurance</span>
            </h2>
            <p class="lead text-muted mb-4">
              PONA HEALTH-X is a flagship social health protection scheme designed to provide
              financial risk protection for the informal sector, particularly rural communities.
            </p>

            <div class="pona-features">
              <div class="feature-row" v-for="feature in ponaFeatures" :key="feature.title">
                <div class="feature-icon-sm">
                  <i :class="feature.icon"></i>
                </div>
                <div class="feature-text">
                  <h6 class="fw-bold mb-1">{{ feature.title }}</h6>
                  <p class="text-muted small mb-0">{{ feature.description }}</p>
                </div>
              </div>
            </div>

            <div class="mt-4">
              <router-link to="/enrollment" class="btn btn-primary btn-lg me-3">
                <i class="bx bx-user-plus me-2"></i>Enroll Now
              </router-link>
              <router-link to="/services" class="btn btn-outline-primary btn-lg">
                <i class="bx bx-info-circle me-2"></i>Learn More
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PONA HEALTH-X Principles -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label-light justify-content-center">
            <span class="label-icon"><i class="bx bx-bulb"></i></span>
            <span class="label-text">Foundation</span>
          </div>
          <h2 class="display-5 fw-bold mb-3 text-white">Core Principles of PONA HEALTH-X</h2>
          <p class="lead opacity-75">The foundational values that guide our health insurance program</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 animate-on-scroll" v-for="(principle, index) in principles" :key="index">
            <div class="principle-card-dark h-100">
              <div class="principle-number">0{{ index + 1 }}</div>
              <div class="principle-icon-wrapper">
                <i :class="principle.icon"></i>
              </div>
              <h4 class="fw-bold mb-3 text-white">{{ principle.title }}</h4>
              <p class="opacity-75 mb-0">{{ principle.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Vision & Mission Section -->
    <section id="vision" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-target-lock"></i></span>
            <span class="label-text">Our Direction</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Vision, Mission & Values</h2>
          <p class="lead text-muted">Guiding principles for healthier communities</p>
        </div>

        <div class="row g-4 mb-5">
          <div class="col-lg-6 animate-on-scroll">
            <div class="vision-mission-card vision">
              <div class="vm-header">
                <div class="vm-icon">
                  <i class="bx bx-bullseye"></i>
                </div>
                <h3 class="fw-bold mb-0 text-white">Our Vision</h3>
              </div>
              <div class="vm-body">
                <p class="vm-quote">
                  "To see healthy, productive, and prosperous communities where every citizen
                  has equitable access to quality healthcare services."
                </p>
                <p class="text-muted mb-0">
                  We envision a world where healthcare is a right, not a privilege. Through PONA HEALTH-X
                  and other initiatives, we are building a healthcare system that protects families,
                  promotes wellness, and drives community development.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="vision-mission-card mission">
              <div class="vm-header">
                <div class="vm-icon">
                  <i class="bx bx-rocket"></i>
                </div>
                <h3 class="fw-bold mb-0 text-white">Our Mission</h3>
              </div>
              <div class="vm-body">
                <p class="vm-quote">
                  "To ensure equitable access to quality and affordable healthcare for all
                  through effective policies, programs, and partnerships."
                </p>
                <p class="text-muted mb-0">
                  We achieve this by strengthening health systems, expanding insurance coverage,
                  training healthcare workers, and collaborating with partners to address the
                  health needs of our diverse population.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Core Values -->
        <div class="values-section animate-on-scroll">
          <h4 class="text-center fw-bold mb-4">Our Core Values</h4>
          <div class="values-grid">
            <div class="value-item" v-for="value in coreValues" :key="value.title">
              <div class="value-icon">
                <i :class="value.icon"></i>
              </div>
              <h6 class="fw-bold mb-2">{{ value.title }}</h6>
              <p class="small text-muted mb-0">{{ value.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Leadership Section -->
    <section id="leadership" class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-user-voice"></i></span>
            <span class="label-text">Our Leaders</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Leadership Team</h2>
          <p class="lead text-muted">Meet the dedicated leaders driving healthcare transformation</p>
        </div>

        <!-- Director -->
        <div class="row justify-content-center mb-5">
          <div class="col-lg-8 animate-on-scroll">
            <div class="minister-card">
              <div class="row align-items-center">
                <div class="col-md-4">
                  <div class="minister-image">
                    <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400"
                         alt="Executive Director"
                         class="img-fluid rounded-4">
                    <div class="minister-badge">
                      <i class="bx bx-crown"></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="minister-info">
                    <h3 class="fw-bold mb-2">Dr. Sarah Johnson</h3>
                    <p class="text-primary fw-bold mb-3">Executive Director</p>
                    <p class="text-muted mb-4">
                      Leading PONA HEALTH-X's transformation with a focus on universal health
                      coverage, digital health innovation, and strengthening primary healthcare systems
                      to improve health outcomes for all communities.
                    </p>
                    <div class="minister-achievements">
                      <span class="achievement-badge">
                        <i class="bx bx-check-circle me-1"></i>Health Systems Expert
                      </span>
                      <span class="achievement-badge">
                        <i class="bx bx-check-circle me-1"></i>Insurance Reform
                      </span>
                      <span class="achievement-badge">
                        <i class="bx bx-check-circle me-1"></i>Coverage Expansion
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Leadership Team -->
        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="leader in leadershipTeam" :key="leader.name">
            <div class="leader-card h-100">
              <div class="leader-image">
                <img :src="leader.image" :alt="leader.name" class="img-fluid">
                <div class="leader-social">
                  <a href="#" class="social-link"><i class="bx bxl-linkedin"></i></a>
                  <a href="#" class="social-link"><i class="bx bx-envelope"></i></a>
                </div>
              </div>
              <div class="leader-info">
                <h5 class="fw-bold mb-1">{{ leader.name }}</h5>
                <p class="text-primary small fw-bold mb-2">{{ leader.position }}</p>
                <p class="text-muted small mb-0">{{ leader.department }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Organizational Structure Section -->
    <section id="structure" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-sitemap"></i></span>
            <span class="label-text">Organization</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Organizational Structure</h2>
          <p class="lead text-muted">How PONA HEALTH-X is organized</p>
        </div>

        <div class="row">
          <div class="col-lg-10 mx-auto animate-on-scroll">
            <div class="org-chart">
              <!-- Top Level -->
              <div class="org-level level-1">
                <div class="org-node minister-node">
                  <i class="bx bx-crown"></i>
                  <span>Executive Director</span>
                </div>
              </div>

              <!-- Second Level -->
              <div class="org-level level-2">
                <div class="org-node">
                  <i class="bx bx-user"></i>
                  <span>Deputy Director<br><small>Health Services</small></span>
                </div>
                <div class="org-node">
                  <i class="bx bx-user"></i>
                  <span>Deputy Director<br><small>Policy & Planning</small></span>
                </div>
              </div>

              <!-- Third Level - Directorates -->
              <div class="org-level level-3">
                <div class="org-node small-node" v-for="dept in departments" :key="dept">
                  <span>{{ dept }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PONA HEALTH-X Structure -->
        <div class="row mt-5">
          <div class="col-lg-10 mx-auto animate-on-scroll">
            <div class="pona-structure-card">
              <h4 class="fw-bold mb-4 text-center">
                <i class="bx bx-shield-check text-primary me-2"></i>
                PONA HEALTH-X Administrative Structure
              </h4>
              <div class="row g-4">
                <div class="col-md-3 text-center">
                  <div class="structure-level">
                    <div class="level-circle federal">
                      <i class="bx bx-buildings"></i>
                    </div>
                    <h6 class="fw-bold mt-3">National Level</h6>
                    <p class="small text-muted">PONA HEALTH-X Headquarters</p>
                  </div>
                </div>
                <div class="col-md-3 text-center">
                  <div class="structure-level">
                    <div class="level-circle regional">
                      <i class="bx bx-map"></i>
                    </div>
                    <h6 class="fw-bold mt-3">Regional Level</h6>
                    <p class="small text-muted">Regional Health Bureaus</p>
                  </div>
                </div>
                <div class="col-md-3 text-center">
                  <div class="structure-level">
                    <div class="level-circle woreda">
                      <i class="bx bx-map-pin"></i>
                    </div>
                    <h6 class="fw-bold mt-3">District Level</h6>
                    <p class="small text-muted">District Health Offices</p>
                  </div>
                </div>
                <div class="col-md-3 text-center">
                  <div class="structure-level">
                    <div class="level-circle kebele">
                      <i class="bx bx-home"></i>
                    </div>
                    <h6 class="fw-bold mt-3">Community Level</h6>
                    <p class="small text-muted">PONA HEALTH-X Schemes / Health Posts</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- History & Timeline Section -->
    <section id="history" class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-history"></i></span>
            <span class="label-text">Our Journey</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">History & Milestones</h2>
          <p class="lead text-muted">Key moments in PONA HEALTH-X's development</p>
        </div>

        <div class="timeline-modern">
          <div class="timeline-item-modern animate-on-scroll"
               v-for="(event, index) in timeline"
               :key="event.year"
               :class="{ 'right': index % 2 !== 0 }">
            <div class="timeline-content-modern">
              <div class="timeline-year-badge">{{ event.year }}</div>
              <h5 class="fw-bold mb-2">{{ event.title }}</h5>
              <p class="text-muted mb-0">{{ event.description }}</p>
              <div class="timeline-icon-modern" :class="event.iconClass">
                <i :class="event.icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Partners Section -->
    <section id="partners" class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-globe"></i></span>
            <span class="label-text">Collaboration</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Our Partners</h2>
          <p class="lead text-muted">Working together to improve healthcare</p>
        </div>

        <!-- Partner Categories -->
        <div class="partner-categories mb-5">
          <ul class="nav nav-pills nav-partner justify-content-center" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" data-bs-toggle="pill" data-bs-target="#international">
                <i class="bx bx-world me-2"></i>International Organizations
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="pill" data-bs-target="#bilateral">
                <i class="bx bx-flag me-2"></i>Bilateral Partners
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="pill" data-bs-target="#ngos">
                <i class="bx bx-heart me-2"></i>NGOs & Foundations
              </button>
            </li>
          </ul>
        </div>

        <div class="tab-content">
          <div class="tab-pane fade show active" id="international">
            <div class="partners-grid animate-on-scroll">
              <div class="partner-card" v-for="partner in internationalPartners" :key="partner.name">
                <div class="partner-logo">
                  <i :class="partner.icon"></i>
                </div>
                <h6 class="fw-bold mb-1">{{ partner.name }}</h6>
                <p class="small text-muted mb-0">{{ partner.role }}</p>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="bilateral">
            <div class="partners-grid animate-on-scroll">
              <div class="partner-card" v-for="partner in bilateralPartners" :key="partner.name">
                <div class="partner-logo">
                  <i :class="partner.icon"></i>
                </div>
                <h6 class="fw-bold mb-1">{{ partner.name }}</h6>
                <p class="small text-muted mb-0">{{ partner.role }}</p>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="ngos">
            <div class="partners-grid animate-on-scroll">
              <div class="partner-card" v-for="partner in ngoPartners" :key="partner.name">
                <div class="partner-logo">
                  <i :class="partner.icon"></i>
                </div>
                <h6 class="fw-bold mb-1">{{ partner.name }}</h6>
                <p class="small text-muted mb-0">{{ partner.role }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Achievements Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label-light justify-content-center">
            <span class="label-icon"><i class="bx bx-trophy"></i></span>
            <span class="label-text">Impact</span>
          </div>
          <h2 class="display-5 fw-bold mb-3 text-white">Our Achievements</h2>
          <p class="lead opacity-75">Measurable impact on healthcare</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="achievement in achievements" :key="achievement.label">
            <div class="achievement-card text-center">
              <div class="achievement-icon">
                <i :class="achievement.icon"></i>
              </div>
              <div class="achievement-value">{{ achievement.value }}</div>
              <div class="achievement-label">{{ achievement.label }}</div>
              <div class="achievement-trend" v-if="achievement.trend">
                <i class="bx bx-up-arrow-alt"></i> {{ achievement.trend }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="cta-card-large animate-on-scroll">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <h2 class="display-6 fw-bold mb-3">Ready to Join PONA HEALTH-X?</h2>
              <p class="lead text-muted mb-4 mb-lg-0">
                Protect your family's health and finances. Enroll in PONA HEALTH-X community-based health insurance
                today and join millions with quality healthcare coverage.
              </p>
            </div>
            <div class="col-lg-4 text-lg-end">
              <router-link to="/enrollment" class="btn btn-primary btn-lg mb-3 me-3">
                <i class="bx bx-user-plus me-2"></i>Enroll Now
              </router-link>
              <router-link to="/contact" class="btn btn-outline-primary btn-lg mb-3">
                <i class="bx bx-phone me-2"></i>Contact Us
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="d-flex align-items-center mb-4">
              <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="40" class="me-3" style="background: white; padding: 5px; border-radius: 8px;">
              <div>
                <div class="fw-bold">PONA HEALTH-X</div>
                <div class="small text-white-50">Community-Based Health Insurance</div>
              </div>
            </div>
            <p class="text-white-50 mb-4">
              Working towards universal health coverage through community-based health insurance.
              Ensuring everyone has access to quality, affordable healthcare.
            </p>
            <div class="social-links">
              <a href="#" class="social-link"><i class="bx bxl-facebook-circle"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-linkedin-square"></i></a>
              <a href="#" class="social-link"><i class="bx bxl-youtube"></i></a>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Quick Links</h6>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/enrollment">Enrollment</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Resources</h6>
            <ul class="footer-links">
              <li><a href="#">FAQs</a></li>
              <li><a href="#">Downloads</a></li>
              <li><a href="#">Publications</a></li>
              <li><a href="#">News</a></li>
            </ul>
          </div>
          <div class="col-lg-4">
            <h6 class="fw-bold mb-3 text-white">Contact Us</h6>
            <ul class="footer-contact">
              <li><i class="bx bx-map me-2"></i>Headquarters</li>
              <li><i class="bx bx-phone me-2"></i>Call: +254 700 000 000</li>
              <li><i class="bx bx-envelope me-2"></i>info@ponahealth.com</li>
            </ul>
          </div>
        </div>
        <hr class="my-4 opacity-25">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0 text-white-50 small">
              © 2025 PONA HEALTH-X. All rights reserved.
            </p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <a href="#" class="text-white-50 small text-decoration-none me-3">Privacy Policy</a>
            <a href="#" class="text-white-50 small text-decoration-none me-3">Terms of Service</a>
            <a href="#" class="text-white-50 small text-decoration-none">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top -->
    <button class="scroll-top-btn" @click="scrollToTop" v-show="showScrollTop">
      <i class="bx bx-chevron-up"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PonaHealthAboutPage',

  data() {
    return {
      showScrollTop: false,
      activeSection: 'organization',

      responsibilities: [
        {
          icon: 'bx bx-file',
          title: 'Policy Development',
          description: 'Formulating health insurance policies, strategies, and guidelines to address healthcare needs.',
          colorClass: 'bg-primary'
        },
        {
          icon: 'bx bx-bar-chart-alt-2',
          title: 'Health Planning',
          description: 'Strategic planning and resource allocation for health sector development.',
          colorClass: 'bg-success'
        },
        {
          icon: 'bx bx-shield-check',
          title: 'Quality Assurance',
          description: 'Setting and monitoring healthcare standards across all facilities nationwide.',
          colorClass: 'bg-info'
        },
        {
          icon: 'bx bx-dollar-circle',
          title: 'Health Financing',
          description: 'Managing health budgets, insurance schemes, and financial protection programs.',
          colorClass: 'bg-warning'
        },
        {
          icon: 'bx bx-user-plus',
          title: 'Human Resources',
          description: 'Training, deployment, and management of healthcare workforce.',
          colorClass: 'bg-danger'
        },
        {
          icon: 'bx bx-world',
          title: 'Partnerships',
          description: 'Coordinating with international partners and stakeholders for health development.',
          colorClass: 'bg-purple'
        }
      ],

      ponaFeatures: [
        {
          icon: 'bx bx-check-shield text-success',
          title: 'Financial Protection',
          description: 'Protects families from catastrophic health expenditures'
        },
        {
          icon: 'bx bx-group text-primary',
          title: 'Community Solidarity',
          description: 'Healthy support sick, rich support poor, young support elderly'
        },
        {
          icon: 'bx bx-dollar text-warning',
          title: 'Affordable Premiums',
          description: 'Income-based premiums with government subsidies for poorest'
        },
        {
          icon: 'bx bx-hospital text-info',
          title: 'Wide Coverage',
          description: 'Access to 3,500+ health facilities nationwide'
        }
      ],

      principles: [
        {
          icon: 'bx bx-group',
          title: 'Solidarity',
          description: 'Community members pool resources to share health risks. The healthy contribute to care for the sick, creating a safety net for all.'
        },
        {
          icon: 'bx bx-balance-left',
          title: 'Equity',
          description: 'Premium contributions are based on ability to pay. The poorest receive full subsidies ensuring no one is left behind.'
        },
        {
          icon: 'bx bx-user-voice',
          title: 'Participation',
          description: 'Communities actively participate in scheme management, governance, and decision-making through elected representatives.'
        }
      ],

      coreValues: [
        { icon: 'bx bx-heart', title: 'Compassion', description: 'Caring for all with empathy' },
        { icon: 'bx bx-check-shield', title: 'Integrity', description: 'Honest and transparent actions' },
        { icon: 'bx bx-star', title: 'Excellence', description: 'Striving for the highest standards' },
        { icon: 'bx bx-group', title: 'Teamwork', description: 'Collaborating for better outcomes' },
        { icon: 'bx bx-bulb', title: 'Innovation', description: 'Embracing new solutions' },
        { icon: 'bx bx-user-check', title: 'Accountability', description: 'Responsible to all stakeholders' }
      ],

      leadershipTeam: [
        {
          name: 'Dr. Michael Chen',
          position: 'Deputy Director',
          department: 'Health Services',
          image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300'
        },
        {
          name: 'Dr. Emily Roberts',
          position: 'Deputy Director',
          department: 'Policy & Planning',
          image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=300'
        },
        {
          name: 'Mr. James Wilson',
          position: 'Director General',
          department: 'PONA HEALTH-X Insurance Agency',
          image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300'
        },
        {
          name: 'Dr. Anna Martinez',
          position: 'Director',
          department: 'Health Insurance Directorate',
          image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300'
        }
      ],

      departments: [
        'Disease Prevention',
        'Health Insurance',
        'Human Resources',
        'Pharmaceuticals',
        'Medical Services',
        'Public Health',
        'Research & Planning',
        'Finance & Admin'
      ],

      timeline: [
        {
          year: '2018',
          title: 'PONA HEALTH-X Established',
          description: 'PONA HEALTH-X officially established to oversee community health insurance.',
          icon: 'bx bx-buildings',
          iconClass: 'bg-primary'
        },
        {
          year: '2019',
          title: 'Pilot Launch',
          description: 'Pilot program launched in select districts to test community health insurance.',
          icon: 'bx bx-test-tube',
          iconClass: 'bg-info'
        },
        {
          year: '2020',
          title: 'National Rollout',
          description: 'PONA HEALTH-X officially launched nationwide targeting informal sector and rural communities.',
          icon: 'bx bx-rocket',
          iconClass: 'bg-success'
        },
        {
          year: '2021',
          title: 'Major Expansion',
          description: 'Program expanded to cover 5+ million households with digital systems introduced.',
          icon: 'bx bx-trending-up',
          iconClass: 'bg-warning'
        },
        {
          year: '2022',
          title: 'Insurance Agency',
          description: 'PONA HEALTH-X Insurance Agency established for better coordination.',
          icon: 'bx bx-shield-check',
          iconClass: 'bg-purple'
        },
        {
          year: '2023',
          title: 'Digital Transformation',
          description: 'Launch of member portal, mobile apps, and digital card systems.',
          icon: 'bx bx-mobile-alt',
          iconClass: 'bg-danger'
        },
        {
          year: '2025',
          title: 'Universal Coverage Goal',
          description: 'Working towards 80% coverage of informal sector with improved services.',
          icon: 'bx bx-target-lock',
          iconClass: 'bg-success'
        }
      ],

      internationalPartners: [
        { name: 'World Health Organization', role: 'Technical Support', icon: 'bx bx-plus-medical' },
        { name: 'World Bank', role: 'Financing & Advisory', icon: 'bx bx-bank' },
        { name: 'UNICEF', role: 'Child & Maternal Health', icon: 'bx bx-child' },
        { name: 'Global Fund', role: 'Disease Programs', icon: 'bx bx-globe' },
        { name: 'GAVI Alliance', role: 'Immunization', icon: 'bx bx-injection' },
        { name: 'African Union', role: 'Regional Coordination', icon: 'bx bx-world' }
      ],

      bilateralPartners: [
        { name: 'USAID', role: 'Health Systems Strengthening', icon: 'bx bx-flag' },
        { name: 'UK FCDO', role: 'Universal Health Coverage', icon: 'bx bx-flag' },
        { name: 'GIZ Germany', role: 'Health Insurance Support', icon: 'bx bx-flag' },
        { name: 'JICA Japan', role: 'Medical Equipment', icon: 'bx bx-flag' },
        { name: 'KOICA Korea', role: 'Digital Health', icon: 'bx bx-flag' },
        { name: 'China Aid', role: 'Infrastructure', icon: 'bx bx-flag' }
      ],

      ngoPartners: [
        { name: 'Bill & Melinda Gates Foundation', role: 'Health Financing', icon: 'bx bx-heart' },
        { name: 'Clinton Health Access Initiative', role: 'Access Programs', icon: 'bx bx-heart' },
        { name: 'PATH', role: 'Innovation & Technology', icon: 'bx bx-heart' },
        { name: 'JSI', role: 'Capacity Building', icon: 'bx bx-heart' },
        { name: 'FHI 360', role: 'Community Health', icon: 'bx bx-heart' },
        { name: 'Save the Children', role: 'Child Health', icon: 'bx bx-heart' }
      ],

      achievements: [
        { icon: 'bx bx-user-check', value: '15M+', label: 'Members Enrolled', trend: '25% YoY' },
        { icon: 'bx bx-hospital', value: '3,500+', label: 'Contracted Facilities', trend: '12% YoY' },
        { icon: 'bx bx-map', value: '850+', label: 'Districts Covered', trend: '98% Coverage' },
        { icon: 'bx bx-heart', value: '85%', label: 'Member Satisfaction', trend: '+5%' }
      ]
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeElements();
    this.observeSections();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    observeElements() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    observeSections() {
      const sections = ['organization', 'pona', 'vision', 'leadership', 'structure', 'history', 'partners'];

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
          }
        });
      }, {
        threshold: 0.3,
        rootMargin: '-150px 0px -50% 0px'
      });

      sections.forEach(id => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 150;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleScroll() {
      this.showScrollTop = window.pageYOffset > 300;
    },

    goToPage(page) {
      this.$router.push(page);
    },

    goToMemberLogin() {
      this.$router.push('/member-login');
    },

    goToStaffLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
/* ========================================================================= */
/* ABOUT PAGE - PONA HEALTH-X STYLES */
/* ========================================================================= */

.about-page {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  background: #fafbfc;
}

/* ========================================================================= */
/* NAVIGATION */
/* ========================================================================= */
.navbar {
  padding: 1rem 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1001;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
}

.brand-title {
  font-weight: 800;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
}

.nav-link {
  font-weight: 600;
  color: #495057 !important;
  transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: #2c5aa0 !important;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 0.5rem;
}

.dropdown-item {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: translateX(5px);
}

/* ========================================================================= */
/* PAGE HEADER */
/* ========================================================================= */
.page-header {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  padding-top: 120px;
  padding-bottom: 60px;
  position: relative;
  overflow: hidden;
}

.header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
}

.header-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse"><path d="M 60 0 L 0 0 0 60" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)" /></svg>');
}

.min-vh-50 {
  min-height: 50vh;
}

.breadcrumb-light {
  background: transparent;
  margin: 0;
  padding: 0;
}

.breadcrumb-light .breadcrumb-item a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-light .breadcrumb-item a:hover {
  color: white;
}

.breadcrumb-light .breadcrumb-item.active {
  color: white;
}

.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.5);
}

/* ========================================================================= */
/* QUICK NAVIGATION */
/* ========================================================================= */
.quick-nav {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px);
}

.nav-scroll-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.nav-scroll-container::-webkit-scrollbar {
  display: none;
}

.nav-quick {
  gap: 0.5rem;
}

.nav-quick .nav-link {
  border-radius: 50px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 0.9rem;
  color: #495057;
  background: #f8f9fa;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.nav-quick .nav-link:hover {
  background: #e3f2fd;
  color: #2c5aa0;
}

.nav-quick .nav-link.active {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(44, 90, 160, 0.3);
}

/* ========================================================================= */
/* SECTION LABELS */
/* ========================================================================= */
.section-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.section-label-light {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.label-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #2c5aa0;
}

.section-label-light .label-icon {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.label-text {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2c5aa0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-label-light .label-text {
  color: rgba(255, 255, 255, 0.9);
}

.text-gradient {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ========================================================================= */
/* IMAGE SHOWCASE */
/* ========================================================================= */
.image-showcase {
  position: relative;
}

.main-image {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
}

.image-showcase:hover .main-image {
  transform: scale(1.02);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);
}

.image-badge {
  position: absolute;
  top: 20px;
  left: 20px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  padding: 0.75rem 1.25rem;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
}

.image-badge.right {
  left: auto;
  right: 20px;
}

.floating-card {
  position: absolute;
  bottom: -30px;
  right: -30px;
  background: white;
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
  animation: float 4s ease-in-out infinite;
}

.floating-card.right {
  right: auto;
  left: -30px;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

.floating-stat {
  text-align: center;
}

.stat-value {
  display: block;
  font-size: 2rem;
  font-weight: 900;
  color: #2c5aa0;
  line-height: 1;
}

.stat-text {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 600;
}

/* ========================================================================= */
/* FACT CARDS */
/* ========================================================================= */
.key-facts {
  margin-top: 2rem;
}

.fact-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.fact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(44, 90, 160, 0.15);
}

.fact-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.bg-primary-soft { background: #e3f2fd; }
.bg-success-soft { background: #d4edda; }
.bg-info-soft { background: #d1ecf1; }
.bg-warning-soft { background: #fff3cd; }

.fact-number {
  font-size: 1.5rem;
  font-weight: 900;
  color: #1e3f70;
  line-height: 1;
}

.fact-label {
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0;
}

/* ========================================================================= */
/* RESPONSIBILITY CARDS */
/* ========================================================================= */
.responsibility-card {
  padding: 2rem;
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border: 2px solid transparent;
}

.responsibility-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
  border-color: #e3f2fd;
}

.resp-icon {
  width: 70px;
  height: 70px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.responsibility-card:hover .resp-icon {
  transform: scale(1.1) rotate(5deg);
}

.bg-primary { background: linear-gradient(135deg, #2c5aa0, #4a90e2) !important; }
.bg-success { background: linear-gradient(135deg, #28a745, #5cb85c) !important; }
.bg-info { background: linear-gradient(135deg, #17a2b8, #5bc0de) !important; }
.bg-warning { background: linear-gradient(135deg, #ffc107, #ffda6a) !important; }
.bg-danger { background: linear-gradient(135deg, #dc3545, #f1707a) !important; }
.bg-purple { background: linear-gradient(135deg, #6f42c1, #9d7bd1) !important; }

/* ========================================================================= */
/* PONA FEATURES */
/* ========================================================================= */
.pona-features {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.feature-row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.feature-row:hover {
  background: #e3f2fd;
  transform: translateX(10px);
}

.feature-icon-sm {
  width: 45px;
  height: 45px;
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

/* ========================================================================= */
/* PRINCIPLE CARDS DARK */
/* ========================================================================= */
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  position: relative;
}

.principle-card-dark {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 2.5rem;
  border-radius: 1.5rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.principle-card-dark:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-10px);
  border-color: rgba(255, 255, 255, 0.3);
}

.principle-number {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 4rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.1);
  line-height: 1;
}

.principle-icon-wrapper {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2.5rem;
  color: white;
  transition: all 0.3s ease;
}

.principle-card-dark:hover .principle-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
  background: rgba(255, 255, 255, 0.3);
}

/* ========================================================================= */
/* VISION & MISSION CARDS */
/* ========================================================================= */
.vision-mission-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
}

.vision-mission-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(44, 90, 160, 0.15);
}

.vm-header {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
}

.vision-mission-card.mission .vm-header {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.vm-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.vm-body {
  padding: 2rem;
}

.vm-quote {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c5aa0;
  font-style: italic;
  margin-bottom: 1rem;
  padding-left: 1.5rem;
  border-left: 4px solid #2c5aa0;
}

/* ========================================================================= */
/* VALUES SECTION */
/* ========================================================================= */
.values-section {
  background: white;
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem;
}

.value-item {
  text-align: center;
  padding: 1.5rem;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.value-item:hover {
  background: #f8f9fa;
  transform: translateY(-5px);
}

.value-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 1.5rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.value-item:hover .value-icon {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  transform: scale(1.1);
}

/* ========================================================================= */
/* MINISTER & LEADERSHIP CARDS */
/* ========================================================================= */
.minister-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}

.minister-image {
  position: relative;
}

.minister-image img {
  border-radius: 1rem;
}

.minister-badge {
  position: absolute;
  bottom: -10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ffc107 0%, #ffda6a 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e3f70;
  font-size: 1.2rem;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.4);
}

.minister-info {
  padding: 1.5rem 0 1.5rem 1.5rem;
}

.minister-achievements {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.achievement-badge {
  background: #e3f2fd;
  color: #2c5aa0;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 600;
}

.leader-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
}

.leader-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.leader-image {
  position: relative;
  overflow: hidden;
}

.leader-image img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  transition: all 0.4s ease;
}

.leader-card:hover .leader-image img {
  transform: scale(1.1);
}

.leader-social {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 3rem 1rem 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
  opacity: 0;
  transition: all 0.3s ease;
}

.leader-card:hover .leader-social {
  opacity: 1;
}

.social-link {
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2c5aa0;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #2c5aa0;
  color: white;
  transform: translateY(-3px);
}

.leader-info {
  padding: 1.5rem;
  text-align: center;
}

/* ========================================================================= */
/* ORGANIZATIONAL STRUCTURE */
/* ========================================================================= */
.org-chart {
  text-align: center;
}

.org-level {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.org-node {
  background: white;
  padding: 1.5rem 2rem;
  border-radius: 1rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.org-node:hover {
  transform: translateY(-5px);
  border-color: #e3f2fd;
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.15);
}

.org-node i {
  font-size: 2rem;
  color: #2c5aa0;
}

.minister-node {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
}

.minister-node i {
  color: white;
}

.small-node {
  padding: 1rem 1.5rem;
  font-size: 0.9rem;
}

.pona-structure-card {
  background: white;
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.structure-level {
  padding: 1.5rem;
}

.level-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.structure-level:hover .level-circle {
  transform: scale(1.15);
}

.level-circle.federal { background: linear-gradient(135deg, #1e3f70, #2c5aa0); }
.level-circle.regional { background: linear-gradient(135deg, #2c5aa0, #4a90e2); }
.level-circle.woreda { background: linear-gradient(135deg, #4a90e2, #6ba8ed); }
.level-circle.kebele { background: linear-gradient(135deg, #6ba8ed, #8fc0f5); }

/* ========================================================================= */
/* MODERN TIMELINE */
/* ========================================================================= */
.timeline-modern {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
}

.timeline-modern::before {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #2c5aa0 0%, #4a90e2 50%, #2c5aa0 100%);
  border-radius: 2px;
}

.timeline-item-modern {
  position: relative;
  width: 50%;
  padding-right: 50px;
  padding-bottom: 50px;
}

.timeline-item-modern.right {
  margin-left: 50%;
  padding-right: 0;
  padding-left: 50px;
}

.timeline-content-modern {
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: all 0.4s ease;
}

.timeline-item-modern:hover .timeline-content-modern {
  transform: translateY(-5px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.2);
}

.timeline-year-badge {
  display: inline-block;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
  font-weight: 800;
  margin-bottom: 1rem;
  box-shadow: 0 4px 15px rgba(44, 90, 160, 0.3);
}

.timeline-icon-modern {
  position: absolute;
  right: -70px;
  top: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.3rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  border: 4px solid white;
}

.timeline-item-modern.right .timeline-icon-modern {
  right: auto;
  left: -70px;
}

/* ========================================================================= */
/* PARTNERS */
/* ========================================================================= */
.nav-partner {
  gap: 0.5rem;
  flex-wrap: wrap;
}

.nav-partner .nav-link {
  border-radius: 50px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  color: #495057;
  background: #f8f9fa;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.nav-partner .nav-link:hover {
  background: #e3f2fd;
  color: #2c5aa0;
}

.nav-partner .nav-link.active {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(44, 90, 160, 0.3);
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.partner-card {
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.partner-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.15);
  border-color: #e3f2fd;
}

.partner-logo {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 2rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.partner-card:hover .partner-logo {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  transform: scale(1.1);
}

/* ========================================================================= */
/* ACHIEVEMENTS */
/* ========================================================================= */
.achievement-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 2.5rem;
  border-radius: 1.5rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  transition: all 0.4s ease;
}

.achievement-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-10px);
  border-color: rgba(255, 255, 255, 0.3);
}

.achievement-icon {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.achievement-card:hover .achievement-icon {
  transform: scale(1.15) rotate(5deg);
}

.achievement-value {
  font-size: 3rem;
  font-weight: 900;
  color: white;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.achievement-label {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
}

.achievement-trend {
  margin-top: 0.75rem;
  color: #4ade80;
  font-weight: 700;
  font-size: 0.9rem;
}

/* ========================================================================= */
/* CTA CARD */
/* ========================================================================= */
.cta-card-large {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  border: 3px solid #e3f2fd;
}

/* ========================================================================= */
/* BUTTONS */
/* ========================================================================= */
.btn {
  padding: 0.875rem 2rem;
  border-radius: 0.75rem;
  font-weight: 700;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border-color: transparent;
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.btn-outline-primary {
  color: #2c5aa0;
  border-color: #2c5aa0;
}

.btn-outline-primary:hover {
  background: #2c5aa0;
  color: white;
}

/* ========================================================================= */
/* FOOTER */
/* ========================================================================= */
footer {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: white;
  padding-left: 8px;
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.footer-contact li {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links .social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-links .social-link:hover {
  background: white;
  color: #2c5aa0;
  transform: translateY(-5px);
}

/* ========================================================================= */
/* SCROLL BUTTON */
/* ========================================================================= */
.scroll-top-btn {
  position: fixed;
  bottom: 35px;
  right: 35px;
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 1.8rem;
}

.scroll-top-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.6);
}

/* ========================================================================= */
/* ANIMATIONS */
/* ========================================================================= */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */
@media (max-width: 992px) {
  .timeline-modern::before {
    left: 30px;
  }

  .timeline-item-modern,
  .timeline-item-modern.right {
    width: 100%;
    padding-left: 80px;
    padding-right: 0;
    margin-left: 0;
  }

  .timeline-icon-modern,
  .timeline-item-modern.right .timeline-icon-modern {
    left: 5px;
    right: auto;
  }

  .floating-card {
    display: none;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding-top: 100px;
    padding-bottom: 40px;
  }

  .page-header h1 {
    font-size: 2.5rem;
  }

  .nav-quick .nav-link {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }

  .minister-card .row {
    text-align: center;
  }

  .minister-info {
    padding: 1.5rem 0 0 0;
  }
}

/* ========================================================================= */
/* UTILITY */
/* ========================================================================= */
.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}
</style>